/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import NewsCard from "./NewsCard";

export default function NewsFeed({ news, activeCategory }) {

    let items = [];

    if (activeCategory === "All") {
        items = Object.values(news).flat();
    } else {
        items = news[activeCategory] || [];
    }

    return (

        <div>

            <div className="
                flex
                items-center
                justify-between
                mb-6
            ">

                <h2 className="text-2xl font-bold">
                    Latest Coverage
                </h2>

            </div>

            <div className="
                grid
                grid-cols-1
                md:grid-cols-2
                xl:grid-cols-3
                gap-6
            ">

                {items.map((item, idx) => (
                    <NewsCard key={idx} item={item} />
                ))}

            </div>

        </div>
    );
}